<template>
    <button :type="type"
            class="inline-flex items-center px-6 py-2 font-medium text-xs text-white uppercase tracking-widest transition">
        <slot></slot>
    </button>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    props: {
        type: {
            type: String,
            default: 'submit',
        },
    },
});
</script>
